import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'code', label: 'Code' },
  { key: 'name', label: 'Name' },
  { key: 'counterparty_name', label: 'Borrower' },
  { key: 'outstanding_principal', label: 'Outstanding Principal', align: 'right', type: 'money' },
  { key: 'next_due_date', label: 'Next Due' },
  { key: 'next_due_amount', label: 'Next Amount', align: 'right', type: 'money' },
  { key: 'effective_yield', label: 'Effective Yield', align: 'right', type: 'percent' },
  { key: 'coverage_ratio', label: 'Coverage Ratio', align: 'right' },
  { key: 'npl', label: 'NPL' },
];

export function LoanPortfolioReport() {
  return (
    <ReportView
      title="Loan Portfolio & Amortisation"
      description="Every loan holding with outstanding principal, next installment due, effective yield, security coverage and NPL status."
      endpoint="/reports/investments/loan-portfolio"
      columns={COLUMNS}
      xlsx
    />
  );
}
